<template>
  <div
    class=""
    v-if="$can(constants.PERMISSION_GESTION_DROITS_REFERENT_LISTE)"
  >
    <add-referent
      :data-to-show="popupAddState"
      @showChange="
        (val) => {
          changeStateAddReferentPopup(val);
        }
      "
    />

    <edit-referent
      :data-to-show="isPopupEditReferentDisplayed"
      :is-admin-payer="isAdminPayer"
      :is-admin-entreprise="isAdminEntreprise"
      @showChange="
        (val) => {
          changeStateEditReferentPopup(val);
        }
      "
    />

    <delete-referent
      :data-to-show="popupDeleteState"
      @showChange="
        (val) => {
          changeStateDeleteReferentPopup(val);
        }
      "
    />

    <!-- BEGIN add new + search + sort -->
    <div
      class="flex content-center items-center justify-between my-15 2xl:my-20 mx-5 lg:mx-15 2xl:mx-20"
    >
      <div class="flex flex-col items-center justify-center mt-5 w-full">
        <div class="flex items-center justify-between w-full px-5 mb-2">
          <!-- BEGIN Button to add a "Referent" -->
          <add-button
            v-if="
              $can(constants.PERMISSION_GESTION_DROITS_REFERENT_AJOUTER)
            "
            libelle="Ajouter un référent"
            @add="displayAddReferentPopup()"
          />
          <!-- END Button to add a "Referent" -->
          <div class="w-2/3 sm:w-1/3">
            <search-bar
              name="searchReferent"
              libelle=""
              :value="searchReferent"
              placeholder="Rechercher un référent"
              :big="false"
              :inherits="false"
              :has-border="false"
              @input="
                (newValue) => {
                  searchReferent = newValue;
                }
              "
            />
          </div>
        </div>
        <div class="w-full px-5 flex items-center justify-end">
          <sort-button
            :sort="sort"
            @sorted="
              (sortType) => {
                sort = sortType;
              }
            "
          />
        </div>
      </div>


      <div class="flex-shrink" />
    </div>
    <!-- END add new + search + sort -->

    <list-grid :list-items="referentsSort">
      <template
        #header
        v-if="referents.length > 0"
      >
        <div class="col-start-1 xl:col-start-2 col-span-5 xl:col-span-3 ml-5 md:ml-10 xl:ml-0">
          Référents
        </div>
        <div class="hidden xl:inline-block col-span-3">
          Rôles
        </div>
        <div class="col-span-5 xl:col-span-2">
          Accès rapide
        </div>
        <div class="col-span-2  mr-5 md:mr-10 truncate">
          Compte réf<span class="inline xl:hidden">.</span><span class="hidden xl:inline">érent</span>
        </div>
      </template>

      <template #errorCases>
        <div
          v-if="referents.length > 0 && referentsSort.length === 0"
          class="flex flex-col justify-center items-center w-full"
        >
          <h3
            class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
          >
            Aucun résultat !
          </h3>
          <h4
            class="text-indigo-600 w-4/6 text-center text-base mt-8 mb-16"
          >
            Aucun référent ne correspond à votre recherche, veuillez
            réessayer avec de nouveaux éléments
          </h4>
          <div>
            <illustration name="no_result" />
          </div>
        </div>
        <div
          v-if="referents.length == 0"
          class="flex flex-col justify-center items-center w-full"
        >
          <h3
            class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
          >
            Aucun référent
          </h3>
          <h4
            class="text-indigo-600 w-4/6 text-center text-base mt-8 mb-16"
          >
            Il n'y a aucun référent rattaché à votre structure
          </h4>
          <div>
            <illustration name="no_result" />
          </div>
        </div>
      </template>

      <!-- BEGIN list of referents -->
      <template #accordionDescription="{ item }">
        <div class="hidden xl:inline-block col-span-1 place-self-center">
          <ProfilePicture
            size="max-w-10 w-10 h-10"
            :other-object="item"
          />
        </div>

        <div
          class="col-span-5 xl:col-span-3 text-lg place-self-center justify-self-start ml-5 md:ml-10 xl:ml-0"
        >
          <!-- Référent -->
          {{ item.firstname }}
          <span class="uppercase">{{ item.lastname }}</span>
        </div>

        <div
          class="hidden xl:inline-block col-span-3 text-lg text-indigo-600 place-self-center justify-self-start"
        >
          <!-- Rôle -->
          <span v-if="item.roles.length > 0">{{ item.roles[0].name }}</span>
        </div>

        <div
          class="col-span-5 xl:col-span-2 place-self-center justify-self-start flex space-x-1"
        >
          <!-- Accès rapides -->
          <router-link
            :to="'/permissions/beneficiariesReferent/' + item.id"
            v-if="
              $can(
                constants.PERMISSION_GESTION_DROITS_REFERENT_DROITS_SUR_NEOPASS
              )
            "
            title="Gestion des droits sur les carnets de parcours du référent"
          >
            <circle-button
              icon="layers"
              label="Gestion des droits sur les carnets de parcours du référent"
              :enable-click="false"
            />
          </router-link>
          <circle-button
            v-if="
              $can(
                constants.PERMISSION_GESTION_DROITS_REFERENT_SUPPRIMER
              ) &&
                user.id != item.id &&
                item.roles[0].name != constants.ROLE_ADMIN_PAYEUR
            "
            icon="close"
            icon-scale="75"
            label="Supprimer le référent"
            @buttonClick="displayConfirmDeletePopup(item)"
          />
        </div>

        <!-- Modifier référent -->
        <div
          v-if="
            $can(
              constants.PERMISSION_GESTION_DROITS_REFERENT_EDITER
            )
          "
          class="col-span-2 place-self-center justify-self-start"
        >
          <action-button
            border-color="border-transparent"
            text-color="text-gray-900"
            bg-color="bg-indigo-300"
            bg-color-square="bg-indigo-200"
            icon-color="text-indigo-600"
            libelle="Compte référent"
            :responsive="true"
            icon="edit"
            @clickAction="displayEditRolePopup(item)"
          />
        </div>
      </template>
      <!-- END list of referents -->
    </list-grid>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Icon from './../../components/Icon';
import CircleButton from './../../components/CircleButton';
import ActionButton from './../../components/ActionButton';
import SortButton from './../../components/SortButton';
import SearchBar from './../../components/Inputs/SearchBar.vue';
import AddButton from './../../components/Inputs/AddButton.vue';

import AddReferent from './popup/AddReferent';
import EditReferent from './popup/EditReferent';
import DeleteReferent from './popup/DeleteReferent';

import ListGrid from './../../components/AccordionTable/ListGrid.vue';

import Constants from './../../constants';
import ProfilePicture from './../../components/ProfilePicture.vue';

export default {
  name: 'Referents',

  components: {
    ProfilePicture,
    Icon,
    CircleButton,
    ActionButton,
    AddReferent,
    EditReferent,
    DeleteReferent,
    SortButton,
    AddButton,
    SearchBar,
    ListGrid,
  },

  data() {
    return {
      popupAddState: -1,
      isPopupEditReferentDisplayed: false,
      popupDeleteState: -1,

      newEmptyReferent: {},

      searchReferent: '',
      sort: 'ABC',
      sortDate: 'olderToYounger',
      constants: Constants,

      isAdminPayer: false,
      isAdminEntreprise: false,
    };
  },

  mounted() {
    this.initEmptyReferent();
  },

  methods: {
    ...mapMutations({
      SET_SAVING: 'permissions/SET_SAVING',
      SET_ERRORS: 'permissions/SET_ERRORS',
      SET_REFERENTTOEDIT: 'referents/SET_REFERENTTOEDIT',
    }),

    ...mapActions({}),

    initEmptyReferent() {
      this.newEmptyReferent = {
        id: null,
        firstname: '',
        lastname: '',
        username: '',
        email: '',
        function: '',
        company: '',
        password: '',
        telephone: '',
        address: '',
        role: null,
      };
    },

    initStatus() {
      setTimeout(() => {
        this.SET_REFERENTTOEDIT({});
      }, 200);
      this.SET_SAVING(false);
      this.SET_ERRORS(null);
      this.isAdminPayer = false;
      this.isAdminEntreprise = false;
    },

    displayAddReferentPopup() {
      this.popupAddState = 1;
      this.SET_REFERENTTOEDIT(this.newEmptyReferent);
    },

    changeStateAddReferentPopup(state) {
      this.popupAddState = state;
      if (state < 0) {
        this.initStatus();
      }
    },

    displayEditRolePopup(referent) {
      this.isPopupEditReferentDisplayed = true;
      this.isAdminPayer = referent.role === Constants.ROLE_ADMIN_PAYEUR;
      this.isAdminEntreprise =
                referent.role === Constants.ROLE_ADMIN_ENTREPRISE;
      this.SET_REFERENTTOEDIT(referent);
    },

    changeStateEditReferentPopup(state) {
      this.isPopupEditReferentDisplayed = state;
      if (!state) {
        this.initStatus();
      }
    },

    displayConfirmDeletePopup(referent) {
      this.SET_REFERENTTOEDIT(referent);

      this.changeStateDeleteReferentPopup(1);
    },

    changeStateDeleteReferentPopup(state) {
      this.popupDeleteState = state;

      if (state < 0) {
        this.initStatus();
      }
    },
  },

  computed: {
    ...mapGetters({
      referents: 'referents/referents',
      referentToEdit: 'referents/referentToEdit',
      user: 'auth/user',
    }),

    //Recherche référent
    referentsFilter: {
      get: function () {
        let filteredList = [];

        filteredList = [...this.referents].filter(
          (referent) =>
            referent.firstname
              .toLocaleLowerCase()
              .includes(
                this.searchReferent.toLocaleLowerCase()
              ) ||
                        referent.lastname
                          .toLocaleLowerCase()
                          .includes(this.searchReferent.toLocaleLowerCase())
        );
        return filteredList;
      },
    },

    //Tri référent
    referentsSort() {
      let sortedList = [];

      if (['ABC', 'ZYX'].includes(this.sort)) {
        sortedList = [...this.referentsFilter].sort(function (a, b) {
          let nameA = a.lastname.toUpperCase();
          let nameB = b.lastname.toUpperCase();
          return nameA.localeCompare(nameB);
        });
      }

      if (['JAN', 'DEC'].includes(this.sort)) {
        sortedList = [...this.referentsFilter].sort(function (a, b) {
          let dateA = a.created_at;
          let dateB = b.created_at;
          return dateA.localeCompare(dateB);
        });
      }

      if (['ABC', 'JAN'].includes(this.sort)) {
        return sortedList;
      }
      if (['ZYX', 'DEC'].includes(this.sort)) {
        return sortedList.reverse();
      }
    },
  },
};
</script>
